import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "ma-wrapper flex-col flex-align-center" }
const _hoisted_2 = { class: "ma-cal" }
const _hoisted_3 = { class: "ma-month flex-row flex-justify-sb shortcut-btn" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = {
  class: "ma-cal-grid",
  id: "calHeaders"
}
const _hoisted_6 = {
  class: "ma-cal-grid",
  id: "calGrid"
}
const _hoisted_7 = ["disabled", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "shortcut-back flex-center",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setMonth(-1)))
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("div", { class: "chev-left" }, null, -1)
        ])),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.monthName), 1),
        _createElementVNode("button", {
          class: "shortcut-fwd flex-center",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setMonth(1)))
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("div", { class: "chev-right" }, null, -1)
        ]))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekdays, (d, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "ma-cal-day flex-center flex-align-end",
            key: i
          }, _toDisplayString(d), 1))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calendar, (day, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "ma-cal-day flex-center fw-bold",
            key: day.date
          }, [
            _createElementVNode("button", {
              class: _normalizeClass(["fw-bold flex-center cal-day-btn", { 'in-month': day.inMonth, available: day.available, closed: day.closed, 'sold-out': day.soldOut, selected: day.selected }]),
              disabled: day.disabled,
              onClick: ($event: any) => (_ctx.$emit('onSelect', day.date)),
              style: _normalizeStyle(day.addDelay ? `transition-delay: ${(i * 25).toFixed(0)}ms` : ''),
              onMouseenter: _cache[2] || (_cache[2] = ($event: any) => ($event.target.removeAttribute('style')))
            }, _toDisplayString(day.number), 47, _hoisted_7)
          ]))
        }), 128))
      ])
    ])
  ]))
}